// src/components/TopHeader.jsx
import React from "react";
import "./TopHeader.css";

const TopHeader = () => {
  return (
    <div className="top-header">
      <div className="top-header-left">
    
      </div>
      <div className="top-header-right">
        <a href="https://www.facebook.com/share/15NKMd8kJv/" target="_blank" rel="noopener noreferrer">
          <i className="fa fa-facebook"></i>
          </a>
        {/* <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
          <i className="fa fa-twitter"></i>
        </a>
        <a href="https://www.youtube.com/channel/" target="_blank" rel="noopener noreferrer">
          <i className="fa fa-youtube"></i>
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <i className="fa fa-instagram"></i>
        </a>
        <a href="https://www.linkedin.com/company/" target="_blank" rel="noopener noreferrer">
          <i className="fa fa-linkedin"></i>
        </a> */}
      </div>
    </div>
  );
};

export default TopHeader;
